// Taşeron portalı — kişi-kapsamlı (personel) belge FORM GÖVDESİ (tür + geçerlilik + not).
//
// S19-D9: bu dosyanın kendi `<Modal>`'ı (`PersonnelDocumentUploadModal` — dosya seçici +
// tekil §8 yükleme + §15.2 link mutasyonu) KALDIRILDI; `personnel/PersonnelDocuments.tsx` artık
// `UploadModal.tsx`'i çağırıyor — bkz. `DocumentUploadModal.tsx`'in tepesindeki aynı not.
//
// Geriye kalan — ve HÂLÂ CANLI olan — kısım, iki tüketicinin ödünç aldığı alan grubudur:
// `PersonnelDocumentFieldGroup` → `UploadModal.tsx` ve `StrandedLinkModal.tsx`.
//
// GL #7: tür listesi §27 kaydının `personnel` türleridir (sabit liste YOK); bitiş tarihi türün
// `expiryRule`'una göre görünür/zorunlu/gizlidir (`components/documents/DocumentTypeFields.tsx`).
//
// **KVKK/PII.** Kişisel evrak (kimlik/sağlık/adli sicil…): alan grubu yalnız METADATA toplar
// (tür + tarih + not); dosyanın kendisi buradan geçmez ve UI documentUuid'i **log'lamaz**.

import { Field, Input, useDocumentTypes, withDocumentType } from '@isgportal/shared';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type DocumentFieldsValue,
  DocumentTypeSelect,
  ValidUntilInput,
  useExpiryRule,
} from './documents/DocumentTypeFields';

/**
 * Kişi-kapsamlı alan grubu (tür + iki tarih + not) — kontrollü, RHF'siz (çağıran,
 * `UploadModal.tsx`, N grubu TEK durumda tutar).
 */
export function PersonnelDocumentFieldGroup({
  idPrefix,
  value,
  onChange,
  disabled,
  typeError,
  typeSelectRef,
}: {
  idPrefix: string;
  value: DocumentFieldsValue;
  onChange: (next: DocumentFieldsValue) => void;
  disabled?: boolean;
  /** Sunucu bu grubun türünü reddetti (`INVALID`/`INACTIVE`) — hata seçicinin altında. */
  typeError?: string;
  /** Ret sonrası odak bu seçiciye taşınır. */
  typeSelectRef?: Ref<HTMLSelectElement>;
}) {
  const { t } = useTranslation();
  const { types } = useDocumentTypes();
  const rule = useExpiryRule('personnel', value.type);
  return (
    <div className="flex flex-col gap-4">
      <DocumentTypeSelect
        id={`${idPrefix}-type`}
        label={t('personnelDocs.field.type')}
        entity="personnel"
        value={value.type}
        disabled={disabled}
        error={typeError}
        selectRef={typeSelectRef}
        onChange={(code) => onChange(withDocumentType(types, 'personnel', value, code))}
      />
      <div className="grid gap-4 sm:grid-cols-2">
        <Field htmlFor={`${idPrefix}-valid-from`} label={t('personnelDocs.field.validFrom')}>
          <Input
            id={`${idPrefix}-valid-from`}
            type="date"
            value={value.validFrom}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, validFrom: e.target.value })}
          />
        </Field>
        <ValidUntilInput
          id={`${idPrefix}-valid-until`}
          label={t('personnelDocs.field.validUntil')}
          rule={rule}
          value={value.validUntil}
          disabled={disabled}
          onChange={(validUntil) => onChange({ ...value, validUntil })}
        />
      </div>
      <Field htmlFor={`${idPrefix}-note`} label={t('personnelDocs.field.note')}>
        <Input
          id={`${idPrefix}-note`}
          value={value.note}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, note: e.target.value })}
        />
      </Field>
    </div>
  );
}
